import store, { AppDispatch } from '../store';
import endpoint from '../util/endpoint';
import { UiProduct } from '@whiz-cart/node-shared/models/product/uiProduct';
import sleep from '@whiz-cart/node-shared/sleep';

export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';
export const CLEAR_PRODUCTS = 'CLEAR_PRODUCTS';
export const UPLOAD_ERROR = 'UPLOAD_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';

export const updateProduct = (...products: Partial<UiProduct & { unknown?: boolean; imageUrl?: string; mhdGroup?: string }>[]) => ({
    type: UPDATE_PRODUCT,
    payload: products.map((product) => ({ gtin: product.gtin, product: { t: new Date(), ...product } })),
});
export const throwUploadError = (error: string) => ({ type: UPLOAD_ERROR, payload: error });
export const clearError = () => ({ type: CLEAR_ERROR });

const requests: Record<string, boolean> = {};
export const fetchProduct = (gtin: string) => async (dispatch: AppDispatch) => {
    if (requests[gtin]) return;
    requests[gtin] = true;

    do {
        try {
            const storeGuid = (await store.awaitState((state) => state.url.params.storeGuid)) ?? '';
            let response = await endpoint('storeManager.getProductByBarcode', { storeGuid, barcode: gtin }).get<UiProduct | undefined>();
            if (response) dispatch(updateProduct(response));
            else {
                response = await endpoint('storeManager.getUnknownProductByBarcode', { storeGuid, barcode: gtin }).get<UiProduct>();
                dispatch(updateProduct({ ...response, gtin, unknown: true }));
            }

            delete requests[gtin];
        } catch (e) {
            console.error(`Could not fetch product ${gtin}. Trying again.`, e);
            await sleep(10000);
        }
    } while (requests[gtin]);
};

export const clearProducts = () => ({ type: CLEAR_PRODUCTS });

export const postProductImage =
    ({ gtin, formData, rotation }: { gtin: string; formData: FormData; rotation: number }) =>
    async (dispatch: AppDispatch) => {
        try {
            const storeGuid = (await store.awaitState((state) => state.url.params.storeGuid)) ?? '';
            // images uploaded with this endpoint appear to only affect MHD/BBD page
            const response = await endpoint('storeManager.uploadProductImage', { storeGuid, barcode: gtin }).post<{
                file: string;
            }>(formData, { params: { rotation } });
            dispatch(updateProduct({ gtin, imageUrl: response.file }));
        } catch (e) {
            console.error(`Could not upload product ${gtin} image`, e);
        }
    };

export const postUnknownProduct =
    ({ gtin, productName, mhdGroup }: { gtin: string; productName: string; mhdGroup?: string }) =>
    async (dispatch: AppDispatch) => {
        try {
            const storeGuid = (await store.awaitState((state) => state.url.params.storeGuid)) ?? '';
            await endpoint('storeManager.uploadUnknownProduct', { storeGuid, barcode: gtin }).post({ name: productName, mhdGroup });
            dispatch(updateProduct({ gtin, name: productName, mhdGroup }));
        } catch {
            dispatch(throwUploadError('Update nicht möglich.'));
            setTimeout(() => {
                dispatch(clearError());
            }, 3500);
        }
    };
